// BABA AI - AI SERVICE
// Together AI integration with Meta-Llama-3.1-405B-Instruct-Turbo
// WITH INTELLIGENT TOOL CALLING

import { routeQuery, buildEnhancedContext } from './toolRouter';

const TOGETHER_API_KEY = '296d74e3e0603d8074249ef9a19908154a20082f85f3bfca3d4a8b7db79bbc2a';
const TOGETHER_API_URL = 'https://api.together.xyz/v1/chat/completions';
const MODEL = 'meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo';

export const sendMessage = async (messages) => {
  try {
    // Get last user message
    const lastUserMessage = messages[messages.length - 1];
    const userQuery = lastUserMessage?.content || '';
    
    // Route query to tools if needed
    const toolResults = await routeQuery(userQuery);
    
    // If tools were called, enhance the context
    let enhancedMessages = messages;
    if (toolResults.length > 0) {
      const enhancedContent = buildEnhancedContext(userQuery, toolResults);
      enhancedMessages = [
        ...messages.slice(0, -1),
        {
          ...lastUserMessage,
          content: enhancedContent
        }
      ];
    }
    
    // Call Together AI
    const response = await fetch(TOGETHER_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${TOGETHER_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        model: MODEL,
        messages: enhancedMessages,
        max_tokens: 4096,
        temperature: 0.7,
        top_p: 0.9,
        top_k: 50,
        repetition_penalty: 1,
        stop: ['<|eot_id|>', '<|eom_id|>']
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Together AI API error: ${errorData.error?.message || response.statusText}`);
    }

    const data = await response.json();
    
    if (!data.choices || !data.choices[0] || !data.choices[0].message) {
      throw new Error('Invalid response from Together AI API');
    }

    return data.choices[0].message.content;
  } catch (error) {
    console.error('AI Service Error:', error);
    throw error;
  }
};

export default { sendMessage };
